// extracted by mini-css-extract-plugin
export default {"paginaGlobal":"PaginaPadrao_paginaGlobal__NvIr3","paginaGlobal__imagem":"PaginaPadrao_paginaGlobal__imagem__qC+tn","paginaGlobal__texto":"PaginaPadrao_paginaGlobal__texto__rein6"};